import { DeleteDeviceSigningParams, OtpRequiredResponse } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const deleteDeviceSigning = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: DeleteDeviceSigningParams
}): Promise<AxiosResponse<OtpRequiredResponse>> => {
  return api.delete<OtpRequiredResponse>(`/devices/signing/${params.id}`)
}
